import { createAction, props } from '@ngrx/store';
import { ServiceError } from '@cigna/chcp/shared/util';

export const saveBrighterFederationPartnerData = createAction(
  '[CoverageDetails] Save Brighter Federation Partner Data',
);
export const saveBrighterFederationPartnerDataSuccess = createAction(
  '[CoverageDetails] Save Brighter Federation Partner Data Success',
);
export const saveBrighterFederationPartnerDataError = createAction(
  '[CoverageDetails] Save Brighter Federation Partner Data Error',
  props<{ error: ServiceError }>(),
);
